// ant design table的排序，搜索功能
import {DataConvert} from "@/utils/utils";

export const myMixins = {
  data() {
    return {
      searchCondition: new Map,
      searchConditionTag: [],
      searchText: '',
      sortList: '',
      inputSearch: '',
      selectSort: [],
    }
  },
  methods: {
    handleSearch(setSelectedKeys, selectedKeys, confirm, column, clearFilters) {
      this.addLoading()
      var isTime = column.dataIndex.toLowerCase().indexOf('time') >= 0
      if (selectedKeys.length > 1) {
        if (typeof selectedKeys[0] === 'object') {
          let date = new Date(selectedKeys[0])
          selectedKeys[0] = DataConvert(date)
        } else {
          let date = new Date("2023-01-01 00:00:00")
          selectedKeys[0] = DataConvert(date)
        }
        if (typeof selectedKeys[1] === 'object') {
          let date = new Date(selectedKeys[1])
          selectedKeys[1] = DataConvert(date)
        }
      } else if (isTime) {
        if (typeof selectedKeys[0] === 'object') {
          let date = new Date(selectedKeys[0])
          selectedKeys[0] = DataConvert(date)
        }
        let date = Date.now()
        selectedKeys[1] = DataConvert(date)
      }
      if (isTime) selectedKeys[0] = selectedKeys[0] + '至' + selectedKeys[1]
      let flag = this.searchCondition.has(column.dataIndex)
      this.searchCondition.set(column.dataIndex, selectedKeys[0])
      let length = this.searchConditionTag.length
      let index
      if (flag) {
        for (var i = 0; i < length; i++) {
          let key = this.searchConditionTag[i].key
          if (key === column.dataIndex) {
            index = i + 1
            break
          }
        }
        if (index) {
          if (selectedKeys[0] === undefined) {
            this.searchConditionTag.splice(index - 1, 1)
            this.searchCondition.delete(column.dataIndex)
          } else {
            this.searchConditionTag[index - 1].value = selectedKeys[0]
          }
        }
      } else {
        if (selectedKeys[0] === undefined) {

        } else {
          this.searchConditionTag.push({
            title: column.title,
            key: column.dataIndex,
            value: selectedKeys[0]
          })
        }
      }
      clearFilters()
      this.updatePageDataBySearch()
      // }
    },
    deleteSelect(item, index) {
      this.addLoading()
      this.searchCondition.delete(item.key)
      this.searchConditionTag.splice(index, 1)
      this.updatePageDataBySearch()
    },

    handleReset(column, clearFilters) {
      clearFilters()
    },
    changeTable(pagination, filters, sorter) {
      this.addLoading()
      let sortName = ''
      this.selectSort = []
      this.sortList = ''
      let field = sorter.field
      if (sorter) {
        switch (sorter.field) {
          case 'analyze.analyzeName':
            field = 'analyzeName';
            break;
          case 'createUser.userName':
            field = 'createUser';
            break;
          case 'analyze.createTime':
            field = 'createTime';
            break;
          case 'analyze.submitTime':
            field = 'execTime';
            break;
          case 'analyze.finishTime':
            field = 'finishedTime';
            break;
          case 'analyze.execStatus':
            field = 'execStatus';
            break;
          case 'analyze.nongroup':
            field = 'nonGroup';
            break;
          case 'projectsRow.projectId':
            field = 'projectId';
            break;
          case 'projectsRow.projectPassword':
            field = 'projectPassword';
            break;
          case 'saler.userName':
            field = 'saleName';
            break;
          case 'customer.userName':
            field = 'customerName';
            break;
          case 'analyzer.userName':
            field = 'analyzeName';
            break;
          case 'projectsRow.category':
            field = 'category';
            break;
          case 'projectsRow.createTime':
            field = 'createTime';
            break;
          case 'projectsRow.note':
            field = 'note';
            break;
          case 'projectsRow.rawdataStatus':
            field = 'rawdataStatus';
            break;
          case 'projectsRow.contractNumber':
            field = 'contractNumber';
            break;
        }
            let order = ''
            if (sorter.order) {
              if (sorter.order === 'ascend') {
                sortName = '升序'
                order = 'asc'

              } else {
                sortName = '降序'
                order = 'desc'
                sorter.order = 'descend'
              }
              if (sorter.column) {
                this.sortList = sorter.column.title + '：' + sortName
              }
              this.selectSort.push({
                order: order,
                colName: field
              })
            }
        this.updatePageData()
      }
    },
    deleteSort() {
      this.addLoading()
      this.selectSort = []
      this.sortList = ''
      this.updatePageData()
    },
  }
}

